import { gql } from "__generated__";

export const GET_SHAREABLE_APPLICATION = gql(`
  query GetShareableApplication($id: String!) {
    getShareableApplication(id: $id) {
      status
      createdAt
      updatedAt
      applicant {
        firstName
        lastName
        email
        phoneNumber
        jobTitle
        yearsOfExperience
      }
      ad {
        id
        title
        description
        employmentType
        location {
          area
          state
          country
        }
        organization {
          id
          name
        }
      }
      education {
        id
        schoolName
        fieldOfStudy
        qualification
        createdAt
      }
      employmentHistory {
        id
        companyName
        jobTitle
        description
        startedAt
        endedAt
        media {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
        createdAt
      }
      projectHistory {
        id
        name
        description
        startedAt
        endedAt
        media {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
        videos
        createdAt
      }
      certifications {
        id
        name
        issuedBy
        issuedAt
        issuerCertificationId
        url
        createdAt
      }
    }
  }
`);

export const MY_JOB_APPLICATIONS = gql(`
  query MyJobApplications($limit: Float) {
    myJobApplications(limit: $limit) {
      id
      education {
        id
        schoolName
        fieldOfStudy
        qualification
        createdAt
      }
      employmentHistory {
        id
        companyName
        jobTitle
        description
        startedAt
        endedAt
        media {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
        createdAt
      }
      projectHistory {
        id
        name
        description
        startedAt
        endedAt
        media {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
        videos
        createdAt
      }
      certifications {
        id
        name
        issuerCertificationId
        issuedBy
        issuedAt
        url
        createdAt
      }
      createdAt
    }
  }
`);

export const GET_MY_PORTFOLIO_FOR_JOB_APPLICATION_PREFILL = gql(`
  query MyPortfolioForJobApplicationPrefill {
    myPortfolio {
      workHistory {
        id
        name
        description
        startedAt
        endedAt
        images {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
      }
      employmentHistory {
        id
        companyName
        jobTitle
        description
        startedAt
        endedAt
        images {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
      }
      certifications {
        id
        name
        issuedBy
        issuedAt
        issuerCertificationId
        url
      }
			educationEntries {
				id
				schoolName
				fieldOfStudy
				qualification
      }
    }
  }
`);

export const DOES_PRO_EXIST = gql(`
  query DoesProExist($email: String!) {
    doesProExistWithEmail(email: $email)
  }
`);

export const DOES_APPLICANT_EXIST = gql(`
  query DoesApplicantExist($email: String!) {
    doesApplicantExistWithEmail(email: $email)
  }
`);

export const MY_JOB_APPLICANT_PROFILE = gql(`
  query MyJobApplicantProfile {
    myJobApplicantProfile {
      firstName
      lastName
      email
      phoneNumber
      yearsOfExperience
      pro {
        id
      }
    }
  }
`);

export const CREATE_RECRUITER_JOB_APPLICATION_LOGGED_IN = gql(`
  mutation CreateRecruiterJobApplicationLoggedIn($input: CreateJobApplicationDto!) {
    createRecruiterJobApplicationLoggedIn(input: $input) {
      id
      applicant {
        pro {
          id
        }
      }
      applicantSnapshot {
        email
        firstName
        lastName
        phoneNumber
        yearsOfExperience
      }
      status
      createdAt
    }
  }
`);

export const CREATE_RECRUITER_JOB_APPLICATION_NOT_LOGGED_IN = gql(`
  mutation CreateRecruiterJobApplicationNotLoggedIn($input: CreateJobApplicationDto!) {
    createRecruiterJobApplicationNotLoggedIn(input: $input) {
      id
      applicant {
        pro {
          id
        }
      }
      applicantSnapshot {
        email
        firstName
        lastName
        phoneNumber
        yearsOfExperience
      }
      status
      createdAt
    }
  }
`);
